import { ContentBlock } from "dtos/content/landing-pages/ContentBlock";

export const ContentBlockDisplay = (props: { block: ContentBlock }) => {
    const { block } = props;
    const { content } = block;

    return <div className="content-block vstack gap-3" dangerouslySetInnerHTML={{ __html: content }}></div>;
};
